import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a678bf1"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-id-card-alt" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-id-card-alt" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-at" }, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Odeslat email o vytvoření účtu")
const _hoisted_5 = {
  key: 0,
  class: "py-m"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Vytvořit nového uživatele ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Zrušit ")

import {
	NInput,
	NButton,
	NResult,
	NAlert,
	NForm,
	NFormItem,
	NSwitch,
	NInputGroup,
	NInputGroupLabel,
	FormRules,
	FormValidationError,
	useMessage,
} from 'naive-ui';
import { reactive, ref } from 'vue';
import { API } from '@/api';
import { useRouter } from 'vue-router';
import BaseFlex from '@/components/layout/BaseFlex.vue';
import { useStore } from 'vuex';

interface Errors {
	no_send_email?: string;
	first_name?: string;
	last_name?: string;
	username?: string;
	message?: string;
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const pending = ref<boolean>(false);
const formRef = ref();
const successMessage = ref<string | undefined>();
const { push: pushRoute } = useRouter();
const message = useMessage();
const { dispatch } = useStore();
const usersRedirect = () => pushRoute('/nastaveni/uzivatele');
const detailUserRedirect = (id: string) => pushRoute(`/nastaveni/uzivatel/${id}`);
const errors = reactive<Errors>({
	no_send_email: undefined,
	first_name: undefined,
	last_name: undefined,
	username: undefined,
	message: undefined,
});
const formModel = ref({
	no_send_email: false,
	first_name: null,
	last_name: null,
	username: null,
});

const rules = ref<FormRules>({
	first_name: [
		{
			required: true,
			message: 'Jméno je povinné',
			trigger: ['input', 'blur'],
		},
	],
	last_name: [
		{
			required: true,
			message: 'Příjmení je povinné',
			trigger: ['input', 'blur'],
		},
	],
	username: [
		{
			required: true,
			// message: 'Uživatelské jméno je povinné',
			validator(rule, value) {
				if (!value) {
					return new Error('Uživatelské jméno je povinné');
				}
				if (!new RegExp(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/, 'i').test(value)) {
					return new Error('Uživatelské jméno musí být email');
				}
				return true;
			},
			trigger: ['input', 'blur'],
		},
	],
});
const submitForm = async () => {
	successMessage.value = undefined;
	errors.first_name = undefined;
	errors.last_name = undefined;
	errors.message = undefined;
	if (formRef.value !== null && typeof formRef.value.validate === 'function') {
		await formRef.value.validate(async (validationErrors: FormValidationError) => {
			if (!validationErrors) {
				pending.value = true;
				try {
					const result: UserResponseDto = await API.users.createNewUser({
						first_name: formModel.value.first_name || '',
						last_name: formModel.value.last_name || '',
						username: (formModel.value.username || '').replace(/\s+/g, ''),
						no_send_email: formModel.value.no_send_email,
						can_login: !formModel.value.no_send_email,
					});

					await dispatch('users/fetchData', true);
					await dispatch('lists/fetchSalesPersons', true);
					message.success('Uživatel byl úspěšně vytvořen.');
					pending.value = false;
					if ('id' in result?.payload && typeof result?.payload?.id !== 'undefined') {
						await detailUserRedirect(result?.payload?.id);
					} else {
						await usersRedirect();
					}
				} catch (error) {
					pending.value = false;
					const catchError: AjaxResponseDto = error as AjaxResponseDto;
					const { message: errorMessage, fields } = catchError?.payload as MessageResponseDto;

					if (typeof fields === 'object' && fields !== null && Object.keys(fields).length > 0) {
						Object.keys(fields).forEach((key) => {
							if (key === 'first_name' || key === 'last_name' || key === 'username') {
								errors[key] = fields[key];
							}
						});
					} else {
						errors.message = errorMessage || 'Neznámá chyba při vytváření uživatele';
					}
				}
			}
		});
	}
};

return (_ctx: any,_cache: any) => {
  return (successMessage.value)
    ? (_openBlock(), _createBlock(_unref(NResult), {
        key: 0,
        status: "success",
        class: "pt-m",
        description: typeof successMessage.value === 'string' ? successMessage.value : ''
      }, null, 8, ["description"]))
    : (_openBlock(), _createBlock(_unref(NForm), {
        key: 1,
        ref_key: "formRef",
        ref: formRef,
        model: formModel.value,
        rules: rules.value,
        style: {"width":"100%"},
        onSubmit: _withModifiers(submitForm, ["prevent"])
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(NFormItem), {
            path: "first_name",
            label: "Jméno",
            feedback: _unref(errors).first_name,
            "validation-status": _unref(errors).first_name ? 'error' : undefined
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NInputGroup), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(NInputGroupLabel), { size: "large" }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(NInput), {
                    value: formModel.value.first_name,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formModel.value.first_name) = $event)),
                    size: "large",
                    placeholder: "Jméno",
                    disabled: pending.value
                  }, null, 8, ["value", "disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["feedback", "validation-status"]),
          _createVNode(_unref(NFormItem), {
            path: "last_name",
            label: "Příjmení",
            feedback: _unref(errors).last_name,
            "validation-status": _unref(errors).last_name ? 'error' : undefined
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NInputGroup), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(NInputGroupLabel), { size: "large" }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(NInput), {
                    value: formModel.value.last_name,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((formModel.value.last_name) = $event)),
                    size: "large",
                    placeholder: "Příjmení",
                    disabled: pending.value
                  }, null, 8, ["value", "disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["feedback", "validation-status"]),
          _createVNode(_unref(NFormItem), {
            path: "username",
            label: "Uživatelské jméno",
            feedback: _unref(errors).username,
            "validation-status": _unref(errors).username ? 'error' : undefined
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NInputGroup), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(NInputGroupLabel), { size: "large" }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(NInput), {
                    value: formModel.value.username,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((formModel.value.username) = $event)),
                    size: "large",
                    placeholder: "Uživatelské jméno",
                    disabled: pending.value
                  }, null, 8, ["value", "disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["feedback", "validation-status"]),
          _createVNode(BaseFlex, {
            row: "",
            "class-name": "py-xs",
            style: {"width":"100%"},
            align: "center"
          }, {
            default: _withCtx(() => [
              _createVNode(BaseFlex, {
                col: "",
                flex: [1, 1]
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }),
              _createVNode(BaseFlex, {
                col: "",
                flex: [0, 0]
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NSwitch), {
                    value: formModel.value.no_send_email,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((formModel.value.no_send_email) = $event)),
                    "checked-value": false,
                    "unchecked-value": true
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_unref(errors).message)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_unref(NAlert), { type: "error" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(errors).message), 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createVNode(BaseFlex, {
            justify: "center",
            align: "center",
            "col-gap": "5px",
            "class-name": "py-m",
            "row-gap": "15px",
            "mobile-col": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NButton), {
                type: "primary",
                size: "large",
                "attr-type": "submit",
                disabled: 
					!!(
						pending.value ||
						formModel.value.first_name === null ||
						formModel.value.first_name === '' ||
						formModel.value.last_name === null ||
						formModel.value.last_name === '' ||
						formModel.value.username === null ||
						formModel.value.username === ''
					)
				,
                loading: pending.value
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["disabled", "loading"]),
              _createVNode(_unref(NButton), {
                type: "default",
                size: "large",
                "attr-type": "button",
                onClick: usersRedirect
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules", "onSubmit"]))
}
}

})